import axios from './financeiroApi';

const parametrosReajusteContratoApi = () => {
  const getPath = () => {
    return `/api/v1/backend/parametros/reajuste-contrato`;
  };

  return {
    cadastrar: (parametrosReajusteContrato) => {
      const url = getPath();
      return axios.post(url, parametrosReajusteContrato);
    },

    atualizar: (id, parametrosReajusteContrato) => {
      const url = `${getPath()}/${id}`;
      return axios.put(url, parametrosReajusteContrato);
    },

    getParametrosReajusteContratoEmpresa: () => {
      const url = getPath();
      return axios.get(url);
    },
  };
};

export { parametrosReajusteContratoApi };
